// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--1AXXX","icon":"Footer-module--icon--1Dkax"};